import { User } from './user.model';

class NullUser extends User {
    constructor() {
        super();
        this.userType = 'nullUser';
    }
}

export const nullUser = new NullUser();